import * as yup from 'yup';
import { MAX_FILE_SIZE, FILE_TOO_LARGE_PATH, ONLY_DIGIT_PERMITED_PATH, 
    REQUIRED_FIELD_PATH, SUPPORTED_FORMATS, FILE_UNSUPPORTED_FORMAT_PATH } from "../../errorMessages";
import { onlyNumbersRegExp } from '../../../helpers/regExps';
import { IFileDataBase64 } from '../../../interface/fileDataBase64.interface';

export const yupObjectCar = {

    carId: yup.string()
        .matches(onlyNumbersRegExp, ONLY_DIGIT_PERMITED_PATH)
        .min(5, 'חייב להכיל לפחות 5 ספרות')
        .max(8, 'לכל היותר 8 ספרות')
        .required(REQUIRED_FIELD_PATH),
    vColor: yup.string()
        .when("hasColorAndType", (hasColorAndType, schema) => {

            if (Array.isArray(hasColorAndType) && hasColorAndType.length > 0) {

                const hasColorAndTypeBool = hasColorAndType[0];

                if (hasColorAndTypeBool === false) {
                    return schema.notRequired();
                }
            }

            return (
                schema
                    .notOneOf(['-1'], 'אנא בחר צבע')
                    .required(REQUIRED_FIELD_PATH)
            );
        }),
    vType: yup.string()
        .when("hasColorAndType", (hasColorAndType, schema) => {

            if (Array.isArray(hasColorAndType) && hasColorAndType.length > 0) {

                const hasColorAndTypeBool = hasColorAndType[0];

                if (hasColorAndTypeBool === false) {
                    return schema.notRequired();
                }
            }

            return (
                schema
                    .notOneOf(['-1'], 'אנא בחר דגם רכב')
                    .required(REQUIRED_FIELD_PATH)
            );
        }),
    scanCarId: yup.mixed()
        .nonNullable()
        .required(REQUIRED_FIELD_PATH)
        .test(
            "FILE_SIZE",
            FILE_TOO_LARGE_PATH,
            (value: IFileDataBase64) => {

                return !value || (value && value.size <= MAX_FILE_SIZE)
            }
        ).test(
            "FILE_FORMAT",
            FILE_UNSUPPORTED_FORMAT_PATH,
            (value: IFileDataBase64) => {

                return !value || (value && SUPPORTED_FORMATS.includes(value?.contentType))
            }
        ),
    scanWorkStatment: yup.mixed()
        .when("ownershipCarType", (ownershipCarType, schema) => {

            if (Array.isArray(ownershipCarType) && ownershipCarType.length > 0) {

                const ownershipCarTypeStr = ownershipCarType[0];

                if (ownershipCarTypeStr === 1 || ownershipCarTypeStr === '1') {
                    return schema.notRequired();
                }
            }

            return (
                schema
                    .nonNullable()
                    .required(REQUIRED_FIELD_PATH)
                    .test(
                        "FILE_SIZE",
                        FILE_TOO_LARGE_PATH,
                        (value: IFileDataBase64) => {

                            return !value || (value && value.size <= MAX_FILE_SIZE)
                        }
                    )
                    .test(
                        "FILE_FORMAT",
                        FILE_UNSUPPORTED_FORMAT_PATH,
                        (value: IFileDataBase64) => {

                            return !value || (value && SUPPORTED_FORMATS.includes(value.contentType))
                        }
                    )
            );
        }),
}